import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_033.jpg';
page.images = [
  {
    imageId: 'page033_zoom0',
    rectangle: {
      x: 920 - 80,
      y: 1814,
      width: 794,
      height: 598,
    },
    imageSrc: 'images/page033/033 6.jpg',
  },
  {
    imageId: 'page033_zoom1',
    rectangle: {
      x: 0,
      y: 1400,
      width: 780,
      height: 598,
    },
    imageSrc: 'images/page033/033 4.jpg',
  },
  {
    imageId: 'page033_zoom2',
    rectangle: {
      x: 920,
      y: 1100,
      width: 804,
      height: 598,
    },
    imageSrc: 'images/page033/033 5.jpg',
  },
  {
    imageId: 'page033_zoom3',
    rectangle: {
      x: 160,
      y: 480,
      width: 510,
      height: 510,
    },
    imageSrc: 'images/page033/032 11.jpg',
  },
  {
    imageId: 'page033_zoom4',
    rectangle: {
      x: 700,
      y: 480,
      width: 510,
      height: 510,
    },
    imageSrc: 'images/page033/032 31.jpg',
  },
  {
    imageId: 'page033_zoom5',
    rectangle: {
      x: 1255,
      y: 480,
      width: 510,
      height: 510,
    },
    imageSrc: 'images/page033/032 41.jpg',
  },
];
export default page;
